<template>
  <div>
    <page-toolbar>
      <kendo-button icon="check" title="Save changes" @click="saveChanges" v-if="!isReadOnly">
      </kendo-button>
      <kendo-button icon="cancel" title="Cancel changes" @click="cancelChanges" v-if="!isReadOnly">
      </kendo-button>
      <flow-type-toolbar
        @change="toolbarChange"
        :marketId="marketId"
        :numberOfPeriods="numberOfPeriods"
        :is-read-only="isReadOnly"
        source="HedgePolicy"
      ></flow-type-toolbar>
    </page-toolbar>
    <div style="height:calc(100vh - 170px)" ref="hedgePolicyGrid"></div>
  </div>
</template>
<script>
import PageToolbar from '@/components/PageToolbar'
import {mapGetters} from 'vuex'
import FlowTypeToolbar from '@/components/FlowTypeToolbar'
import notification from '@/helpers/notification'
import axios from 'axios'
import {numericEditor} from '@/helpers/kendo-editors'
import {enableCustomExportExcel} from '@/helpers/export-helper'
import security from '@/mixins/security'

const $ = kendo.jQuery

export default {
  mixins: [security],
  computed: {
    ...mapGetters({clientId: 'authentication/selectedClientId'}),
    ...mapGetters({marketId: 'app/marketId'}),
  },
  components: {
    PageToolbar,
    FlowTypeToolbar,
  },
  data() {
    return {
      showFileUploadDialog: false,
      numberOfPeriods: 12,
    }
  },
  beforeDestroy() {
    const $container = $(this.$refs.hedgePolicyGrid)
    let grid = $container.getKendoGrid()
    if (grid != null) {
      grid.destroy()
    }
  },
  methods: {
    toolbarChange(e) {
      this.createGrid(e)
    },
    saveChanges() {
      const $container = $(this.$refs.hedgePolicyGrid)
      const grid = $container.getKendoGrid()
      grid.saveChanges()
    },
    cancelChanges() {
      const $container = $(this.$refs.hedgePolicyGrid)
      const grid = $container.getKendoGrid()
      grid.cancelChanges()
    },
    createGrid(options) {
      const vm = this
      let $container = $(vm.$refs.hedgePolicyGrid)
      let editable = !vm.isReadOnly
      let showExcelButton = true
      const url = '/api/config/HedgePolicy'

      return new Promise(function(gridResolve) {
        axios
          .get(url, {
            params: {
              clientId: options.clientId,
              ccyPairId: options.ccyPairId,
              flowTypeId: options.flowTypeId,
              hedgePolicyDate: options.date,
            },
          })
          .then(function(result) {
            let response = result.data
            let columns = response.columns

            let dataSource = new kendo.data.DataSource({
              transport: {
                read: function(options) {
                  options.success(response)
                },
                update: function(e) {
                  let data = e.data.models.map(function(data) {
                    return vm.getDataItem(data, columns)
                  })
                  axios.put(url, {clientId: options.clientId, dataItems: data}).then(function() {
                    e.success(true)
                  })
                },
              },
              schema: {
                data: 'data',
                errors: 'errors',
                model: {
                  id: 'Month',
                  fields: vm.getDynamicFields(columns, editable),
                },
              },
              batch: true,
            })

            let hedgePolicyGrid = $container.getKendoGrid()
            if (hedgePolicyGrid != null) {
              hedgePolicyGrid.destroy()
            }

            hedgePolicyGrid = $container
              .empty()
              .kendoGrid({
                navigatable: true,
                dataSource: dataSource,
                editable: editable && 'incell',
                hidden: false,
                resizable: false,
                reorderable: false,
                sortable: true,
                columns: vm.getGridColumns(columns, editable),
              })
              .data('kendoGrid')

            hedgePolicyGrid.trigger('dataBound')
            gridResolve(hedgePolicyGrid)
            vm.numberOfPeriods = response.data.length

            let gridToolbar = $('.page_toolbar-item')

            const validDate = options.date !== '0001-01-01'
            if (editable && validDate) {
              let $button = $(
                "<a class='AddNew k-button k-button-icontext' href='javascript:;' title='Add New Record'><i class='k-icon k-i-plus'></i></a>",
              )
              $button.off('click').on('click', function() {
                axios
                  .post(url, {
                    clientId: options.clientId,
                    ccyPairId: options.ccyPairId,
                    flowTypeId: options.flowTypeId,
                    hedgePolicyDate: options.date,
                  })
                  .then(function(result) {
                    let response = result.data
                    if (response.errors) {
                      let message = response.Errors.Item.errors
                      notification(message, 'error')
                    } else {
                      vm.createGrid(options)
                    }
                  })
              })
              $('.page_toolbar-item .AddNew').remove()
              gridToolbar.append($button)

              $container
                .off('click', '.deleteHedgePolicyMonth')
                .on('click', '.deleteHedgePolicyMonth', function() {
                  var monthNumber = $(this).data('monthnumber')
                  axios
                    .delete(url, {
                      params: {
                        clientId: options.clientId,
                        ccyPairId: options.ccyPairId,
                        flowTypeId: options.flowTypeId,
                        hedgePolicyDate: options.date,
                        monthNumber: monthNumber,
                      },
                    })
                    .then(function() {
                      vm.createGrid(options)
                    })
                })
            } else {
              $('.page_toolbar-item .AddNew').remove()
            }

            if (showExcelButton) {
              $.ajaxSettings.traditional = true
              let params = $.param({
                clientId: options.clientId,
                ccyPairId: options.ccyPairId,
                flowTypeId: options.flowTypeId,
                hedgePolicyDate: options.date,
              })
              delete $.ajaxSettings.traditional

              $('.page_toolbar-item .exportToExcel').remove()
              const excelUrl = url + '/exportHedgePolicyToExcel' + '?' + params
              enableCustomExportExcel(gridToolbar, excelUrl)
            }
          })
      })
    },
    getGridColumns(columns, editable) {
      let allColumns = [
        {
          field: 'HedgePolicyDate',
          title: 'HedgePolicyDate',
          hidden: true,
        },
        {
          field: 'MonthNumber',
          title: 'MonthNumber',
          hidden: true,
        },
        {
          field: 'CcyPairId',
          title: 'CcyPairId',
          hidden: true,
        },
        {
          field: 'FlowTypeId',
          title: 'FlowTypeId',
          hidden: true,
        },
        {
          field: 'Month',
          title: 'Month',
          lockable: false,
          hidden: false,
          width: 105,
          sortable: true,
        },
      ]

      columns.forEach(function(column) {
        allColumns.push({
          field: column.columnName,
          title: column.title,
          headerAttributes: {style: 'text-align: center; font-size: 12px;'},
          attributes: {style: 'text-align: right;'},
          sortable: false,
          format: '{0:p0}',
          width: 132,
          editor: numericEditor(
            {
              format: 'p0',
              factor: 100,
              spinners: false,
              decimals: 4,
              step: 0,
            },
            false,
          ),
        })
      })

      allColumns.push({
        width: '60px',
        attributes: {style: 'text-align: center;'},
        visible: editable,
        template: dataItem => {
          if (!dataItem.CanBeDeleted || this.isReadOnly) {
            return ''
          }

          const template =
            '<a class="deleteHedgePolicyMonth" data-monthnumber="' +
            dataItem.MonthNumber +
            '"  href="javascript:;">  <span class="k-icon k-i-delete"></span></a>'
          return template
        },
      })

      return allColumns
    },
    getDynamicFields(columns, editable) {
      let fields = {
        monthNumber: {type: 'number', editable: false},
        month: {type: 'string', editable: false},
        flowTypeId: {type: 'number', editable: false},
        ccyPairId: {type: 'number', editable: false},
        hedgePolicyDate: {type: 'date', editable: false},
      }

      columns.forEach(function(column) {
        fields[column.columnName] = {field: column.columnName, editable: editable, required: true}
      })

      fields['CanBeDeleted'] = {type: 'bool', defaultValue: true, editable: false}
      fields['Month'] = {type: 'string', editable: false}

      return fields
    },
    getDataItem(data, columns) {
      let validColumns = columns
      let monthNumber = data['MonthNumber']
      let ccyPairId = data['CcyPairId']
      let flowTypeId = data['FlowTypeId']
      let hedgePolicyDate = kendo.toString(data['HedgePolicyDate'], 'yyyy-MM-dd')
      let hedgePolicyItems = []

      validColumns.forEach(function(column) {
        let newDataItem = {
          DivisionId: column.divisionId,
          Value: data[column.columnName],
        }
        hedgePolicyItems.push(newDataItem)
      })

      let dataItem = {
        MonthNumber: monthNumber,
        CcyPairId: ccyPairId,
        FlowTypeId: flowTypeId,
        HedgePolicyDate: hedgePolicyDate,
        HedgePolicyItems: hedgePolicyItems,
      }

      return dataItem
    },
  },
}
</script>
